export default __webpack_public_path__ + "static/media/gallery_06.4c7d419c.jpg";